export const hasSearchParams = window.location.search.length > 0;

export const hasFilterUrl = (value: string, type: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = searchParams.get(type);

    if (!params) return false;

    return params.split('.').includes(`${value}`);
};

export const getFilterUrlValues = (type: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = searchParams.getAll(type);

    return params.map(param => param.split('.'));
};

export const getFilterUrlValue = (type: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    const param = searchParams.get(type);

    return param;
};
